export class CalculateResponseModel {
  constructor(
    public success: boolean,
    public calorie: string,
    public calories: Calorie[]
  ) {}
}

export class Calorie {
  constructor(
    public difficulty: string,
    public amount: number,
    public suitable: boolean
  ) {}
}

export class PredefinedDietsResponseModel {
  constructor(
    public success: boolean,
    public count: number,
    public preDefinedDiets: PredefinedDiet[]
  ) {}
}

export class PredefinedDiet {
  constructor(
    public days: number,
    public id: string,
    public type: PredefinedDietType
  ) {}
}

export class PredefinedDietType {
  constructor(
    public description: string,
    public imagePath: string,
    public name: string,
    public id: string
  ) {}
}
